
import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from '../../store/modules/user'
import StudentData from '../../components/Dashboards/StudentData.vue'
import SaleData from '../../components/Dashboards/SaleData.vue'
import AuditionManage from '../../components/Dashboards/AuditionManage.vue'
import MarketData from '../../components/Dashboards/MarketData.vue'
import CustomerData from '../../components/Dashboards/CustomerData.vue'
import OrderData from '../../components/Dashboards/OrderData.vue'
import TeacherData from '../../components/Dashboards/TeacherData.vue'
import PanelHeader from '../../components/Dashboards/PanelHeader.vue'

@Component({
  name: 'Dashboards',
  components: {
    AuditionManage,
    StudentData,
    SaleData,
    MarketData,
    CustomerData,
    OrderData,
    TeacherData,
    PanelHeader
  }
})
export default class extends Vue {

  activeName = 'first'
  instrumentTypes = []
  teacherType = []
  campusType = []
  time = [new Date(<any>new Date() - 1000 * 60 * 60 * 24 * 30),new Date()]
  is_index_change = false
  ages: any = []
  source: any = []
  showTeacher: boolean = true
  showSource: boolean = true

  handleClick(tab, event) {
    if (this.activeName === 'seventh') {
      this.showSource = false
    } else {
      this.showSource = true
    }
  }
  getData(val) {
    this.is_index_change = false
  }
  getSelectChange(val: any) {
    this.is_index_change = true
  }
}
